import { useState, useEffect, useRef } from "react";
import React from "react";
import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import Wrapper from "../../../components/UI/Wrapper";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import CryptoJS from "crypto-js";
import axios from "axios";

import ShipmentDetail from "../../../components/ViewShipmentDetail/ShipmentDetail/ShipmentDetail";
import ExpenseDetail from "../../../components/ViewShipmentDetail/ExpenseDetail/ExpenseDetail";
import ExecutionAndDocumentation from "../../../components/ViewShipmentDetail/ExecutionAndDocumentation/ExecutionAndDocumentation";
import ProfitAndLoss from "../../../components/ViewShipmentDetail/ProfitAndLoss/ProfitAndLoss";
import LeadDocuments from "../../../components/LeadDocuments/LeadDocuments";
import LeadPaymentDetails from "../../../components/LeadPaymentDetails/LeadPaymentDetails";
import AccountsLeadRefundDetails from "../../../components/AccountsLeadRefundDetails/AccountsLeadRefundDetails";
import AccountsBillingDetails from "../../../components/AccountsBillingDetails/AccountsBillingDetails";

const ViewShipmentListDetail = () => {
  const [relocationId, setRelocationId] = useState("");
  const [activeDetail, setActiveDetail] = useState("shipment");
  const navigate = useNavigate();
  const location = useLocation();
  const [isEditMode, setIsEditMode] = useState(false);
  const baseAPI = process.env.REACT_APP_API_URL;
  const [serviceTypeResponse, setServiceTypeResponse] = useState({});
  const [quotation, setquotation] = useState(0);
  const [estimateDetail, setEstimateDetail] = useState([]);
  const baseImageURL = process.env.REACT_APP_IMAGE_URL;

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const encryptedRelocationID = searchParams.get("Relocation_ID");
    const Relocation_ID = decryptRelocationID(encryptedRelocationID);

    if (Relocation_ID) {
      getServiceTypeForLead(Relocation_ID)
      getQuotationAmount(Relocation_ID);
      getInvoiceDetail(Relocation_ID);
    }
  }, []);


  function getServiceTypeForLead(Relocation_ID) {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}Userget/GetServiceTypeForLead?Relocation_ID=${Relocation_ID}`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        setServiceTypeResponse(response.data.data[0]);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  function getQuotationAmount(Relocation_ID) {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}Userget/getQuotationAmount?Relocation_ID=${Relocation_ID}`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        let amt = 0;
        amt = Number(response.data?.data[0]) || 0;
        setquotation(amt);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  function getInvoiceDetail(Relocation_ID) {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}Userget/EstimateListDetaile?search_param=${Relocation_ID}&Status=-1`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {       
        setEstimateDetail(response.data.data);
      })
      .catch((error) => {        
        console.error("Error fetching user detail:", error);
      });
  }


  function decryptRelocationID(ciphertext) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        decodeURIComponent(ciphertext),
        "dbbworldwidepvtltd"
      );
      setRelocationId(bytes.toString(CryptoJS.enc.Utf8));
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting Relocation_ID:", error);
      return null;
    }
  }

  return (
    <div>
      <div className="app-container-viewLeadDetails">
        <MiniDrawer />
        <div
          style={{ overflowX: "hidden" }}
          className="container-fluid container-viewLeadDetails"
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "1rem",
            }}
            className="country-header"
          >
            <div>
              <h1 style={{ fontSize: "24px" }}>
                <b> View Shipment List </b> | <HomeOutlinedIcon /> &gt;
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/ShipmentList")}
                >
                  Accounts & Finance{" "}
                </a>
                <span style={{ fontSize: "20px" }}>&gt; Shipment List</span>{" "}
                <span style={{ fontSize: "20px" }}>
                  &gt; View Shipment List
                </span>
              </h1>
            </div>
            <div>
              {relocationId ? (
                <div style={{ backgroundColor: "#682465" }}>
                  <h5
                    style={{
                      color: "white",
                      fontSize: "16px",
                      padding: "10px",
                    }}
                  >
                    Lead ID:{relocationId}
                  </h5>
                </div>
              ) : null}
            </div>
          </div>
          <Wrapper className="LeadDetails">
            {/* ----------------------------------Quotation builder-------------------------------- */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <b
                  style={{
                    color: "#3D3D3D",
                    fontSize: "24px",
                    margin: "0px",
                    padding: "0px",
                  }}
                >
                  {serviceTypeResponse.ServiceTypeName}
                  <span style={{ fontSize: "16px", color: "black" }}>
                    ({serviceTypeResponse.delivery_type_name})
                  </span>
                </b>
              </div>
              {estimateDetail.length > 0 && (
                <div>
                  <button
                    className="btn btn-primary btn-primary-estimate"
                    style={{
                      margin: "0rem",
                      backgroundColor: estimateDetail?.[0]?.estimate_attachment ? "white" : "#f0f0f0",
                      color: estimateDetail?.[0]?.estimate_attachment ? "#6A6A6A" : "#a0a0a0",
                      borderColor: "#C0C6CC",
                      whiteSpace: "nowrap",
                      width: "auto",
                      cursor: estimateDetail?.[0]?.estimate_attachment ? "pointer" : "not-allowed",
                    }}
                    disabled={!estimateDetail?.[0]?.estimate_attachment}
                    onClick={() => {
                      if (estimateDetail?.[0]?.estimate_attachment) {
                        window.open(`${baseImageURL}Images/Documents/${relocationId}/${estimateDetail[0].estimate_attachment}`, "_blank");
                      }
                    }}
                  >
                    QUOTATION - {estimateDetail[0].finalAfterGateway}
                  </button>
                </div>
              )}
            </div>
          </Wrapper>
          <div>
            <div
              style={{
                marginTop: "11px",
                backgroundColor: "rgb(243 243 243)",
                overflowX: "auto",
              }}
              className="LeadDetails px-0"
            >
              <div
                className="d-flex justify-content-start align-items-center"
                style={{ minWidth: "900px", padding: "0 20px" }}
              >
                {[
                  { key: "shipment", label: "Shipment Details" },
                  { key: "scopeOfWork", label: "Scope Of Work" },
                  { key: "documentation", label: "Documentation" },
                  { key: "payment", label: "Payment Detail" },
                  
                  { key: "billing", label: "Billing Details" },
                  { key: "expense", label: "Expense Details" },
                  { key: "profit", label: "Profit & Loss" },
                ].map(({ key, label }) => (
                  <div
                    key={key}
                    onClick={() => setActiveDetail(key)}
                    style={{ cursor: "pointer", minWidth: "120px" }}
                    className="text-center mx-2"
                  >
                    <h4
                      style={{
                        fontWeight: "600",
                        fontSize: "14px",
                        color: activeDetail === key ? "#5B489D" : "#6a6a6a",
                        borderBottom:
                          activeDetail === key ? "3px solid #5B489D" : "none",
                        paddingBottom: "3px",
                      }}
                    >
                      {label}
                    </h4>
                  </div>
                ))}
              </div>
            </div>
            <hr
              style={{ marginTop: "-30px", padding: "0px", marginBottom: "30px" }}
            />
            {activeDetail === 'shipment' ?
              <ShipmentDetail />
              :
              activeDetail === 'expense' ?
                <ExpenseDetail relocation_id={relocationId} />
                :
                activeDetail === 'documentation' ?
                  // <ExecutionAndDocumentation />
                  <LeadDocuments Priority_upload={"1"} />
                  :
                  activeDetail === 'profit' ?
                    <ProfitAndLoss />
                    :
                    activeDetail === 'payment' ?
                      <LeadPaymentDetails Relocation_Id={relocationId} isEditMode={isEditMode} setIsEditMode={setIsEditMode} module="accounts" />
                      : activeDetail === "refund" ? (
                        <AccountsLeadRefundDetails Relocation_Id={relocationId} />
                      ) : activeDetail === "billing" ? (
                        <AccountsBillingDetails Relocation_Id={relocationId} quotation_amount={quotation} />
                      ) : null
            }
          </div>
          {/* ------------------------customer deatil--------------------- */}
        </div>
      </div>
    </div>
  );
};

export default ViewShipmentListDetail;
